module.exports = __webpack_public_path__ + "images/paper-add.1787648603550.png";